var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0539 7.14258C13.1863 8.19958 12.9851 9.27154 12.4785 10.2086C11.972 11.1457 11.1853 11.9011 10.2284 12.3693C9.2715 12.8375 8.19227 12.995 7.14151 12.8198C6.09074 12.6447 5.12096 12.1456 4.36768 11.3924",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90366 8.36034C2.82189 7.64472 2.89224 6.91989 3.11011 6.23335C3.32798 5.54681 3.68845 4.91405 4.1679 4.37653C4.64735 3.83901 5.23496 3.40885 5.89223 3.11424C6.54951 2.81963 7.26161 2.66722 7.98189 2.667C8.65309 2.66611 9.31785 2.79781 9.938 3.05453C10.5582 3.31126 11.1215 3.68796 11.5957 4.163",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 6.22266L2.9035 8.36022L4.88906 6.6671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6669 9.33369L13.0538 7.14258L11.1113 8.88925",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadV2);
export default __webpack_public_path__ + "static/media/ReloadV2.61fb7bcd.svg";
export { ForwardRef as ReactComponent };